import { ReactNode } from 'react';
import Typography from '../Typography';
import { Alert } from '../Alert';
import { ErrorOutlineIcon } from '../Icons';

interface ZoomInfoBoxProps {
    children: ReactNode;
    'data-testid': string;
    useNewVersion?: boolean;
}

/**
 *  Zoom information that will render if a chip is disabled
 */
const ZoomInfoBox = ({ children, 'data-testid': dataTestId }: ZoomInfoBoxProps) => {
    return (
        <Alert
            icon={<ErrorOutlineIcon fontSize="medium" />}
            variant="filled"
            sx={(theme) => ({
                zIndex: 11,
                px: 1,
                py: 0.5,
                marginBottom: 1,
                marginLeft: -1.5,
                marginRight: -1.5,
                display: 'flex',
                alignItems: 'center',
                '& > .MuiAlert-message ': {
                    padding: 0
                },
                backgroundColor: theme.palette.lightYellow.main
            })}
            data-testid={dataTestId}
        >
            <Typography variant="body2">{children}</Typography>
        </Alert>
    );
};

export default ZoomInfoBox;
